import { Navbar, Footer } from '../components/layout'
import {
  Hero,
  HowItWorks,
  PlatformModules,
  UnifiedIdentity,
  WhoItsFor,
  TrustCredibility,
  FinalCTA,
} from '../components/sections'
import './LandingPage.css'

function LandingPage() {
  return (
    <div className="landing-page">
      {/* Noise overlay for texture */}
      <div className="bg-noise" aria-hidden="true"></div>
      
      <Navbar />
      
      <main>
        <Hero />
        <HowItWorks />
        <PlatformModules />
        <UnifiedIdentity />
        <WhoItsFor />
        <TrustCredibility />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  )
}

export default LandingPage
